import { type PayloadAction, createSlice } from '@reduxjs/toolkit';


import { type ParkingWithCompanies } from '@/parking/domain/parking';

export interface ParkingsSlice {
    companiesByParking: ParkingWithCompanies[],
}

const initialState: ParkingsSlice = {
    companiesByParking: [],
};


const parkingsSlice = createSlice({
    initialState,
    name: 'parkings',
    reducers: {
        clearCompaniesByParking: () => initialState,
        clearPendingParking() {
            return initialState;
        },
        setCompaniesByParking: (state, action: PayloadAction<ParkingWithCompanies[]>) => {
            state.companiesByParking = action.payload;
            return;
        }
    }

});

export const { setCompaniesByParking, clearPendingParking } = parkingsSlice.actions;
export default parkingsSlice.reducer;
